import roles from '@/constants/roles';

export const publicRoutes = ['login', 'oauth2-authorized', 'password-expired'];

export const allUserRoutes = [
    'how-it-works',
    'profile-setup',
    'organization-profile',
    'new-opportunity',
    'edit-opportunity',
    'opportunity-details',
    'dashboard',
    'volunteer-profile',
    'browse-org-volunteers',
    'asset-details',
    'organization-content',
    'organization-category-content',
    'connect-directory',
    'request-details',
    'error',
    'message',
    'settings',
];

export const orgAdminRoutes = ['user-management', 'organization-settings'];

export const groupAdminRoutes = [];

export const deAdminRoutes = [
    'org-management',
    'educator-management',
    'request-admin',
    'request-details',
    'test-asset',
    'feature-flags',
    'request-templates',
    'new-request',
    'new-group',
    'edit-group',
    'browse-groups',
    'group-details',
    'group-admins',
    'group-statistics',
];

export const educatorRoutes = [
    'browse-volunteers',
    'browse-organizations',
    'new-request',
    'new-request-v2',
    'request-edit',
    'request-edit-v2',
    'request-duplicate',
    'browse-content',
    'direct-request',
    'spotlight-content',
    'share-my-career',
    'group-details',
];

export const roleRoutes = {
    [roles.DE_ROLE]: deAdminRoutes,
    [roles.ORGADMIN_ROLE]: orgAdminRoutes,
    [roles.GROUPADMIN_ROLE]: groupAdminRoutes,
    [roles.EDUCATOR_ROLE]: educatorRoutes,
};
